import React from 'react'
import { SceneNode } from '@/features/screenplay/components/editor/nodes/SceneNode'
import { getSceneHeader } from '@/shared/utils/editor-utils'
import { LexicalEditor } from 'lexical'
import { Shot } from '../store/useShotListStore'
import { PdfService } from '@/shared/services/pdf.service'
import { ShotListPDFTemplate } from '../components/pdf/ShotListPDFTemplate'

export const downloadShotListPDF = async (
    projectTitle: string,
    allScenes: SceneNode[],
    shotLists: Record<string, Shot[]>,
    editor: LexicalEditor,
    options: { type: 'whole' | 'single'; sceneId?: string }
) => {
    // Filter scenes based on options
    let targetScenes = allScenes

    if (options.type === 'single' && options.sceneId) {
        targetScenes = allScenes.filter(s => s.id === options.sceneId)
    }

    if (!targetScenes || targetScenes.length === 0) {
        console.warn("No scenes found to export.")
        return
    }

    // Map scenes to data structure
    const scenesData = targetScenes.map(scene => {
        const shots = shotLists[scene.id] || []
        // Use utility to extract scene header text safely
        const sceneName = editor.read(() => getSceneHeader(scene))
        return {
            sceneName,
            shots
        }
    }).filter(item => options.type === 'single' || item.shots.length > 0)

    if (scenesData.length === 0) {
        alert("No shots found in the selected scope.")
        return
    }

    try {
        console.log("Generating React-PDF for Shot List...")
        
        // Fetch brand logo
        const brandLogoBase64 = await PdfService.fetchBrandLogoBase64();

        const documentElement = (
            <ShotListPDFTemplate 
                projectTitle={projectTitle} 
                scenesData={scenesData} 
                brandLogoBase64={brandLogoBase64}
            />
        )

        const fileName = `${projectTitle.replace(/\s+/g, '_')}_ShotList`
        await PdfService.downloadReactPdfDocument(documentElement, fileName)
        
        console.log("React-PDF Shot List saved completed.")
    } catch (err) {
        console.error("PDF Generation failed:", err)
        alert("Failed to generate PDF. Check console.")
    }
}
